module.exports = __webpack_public_path__ + "img/car_half.0a68369d.svg";